import { DefaultService } from '@/services/DefaultService';

export default class ConfigExtraService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAllByTabela(tabela, aba) {
        return this._http.get(encodeURI(`${this._env}/configextra/all.json?tabela=${tabela}&aba=${aba}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}